export default function() {
	$(".js-countdown").each(function(){
		$(this).countdown($(this).attr('data-datetime'), function(event) {
			$(this).text(
				event.strftime('%D дней : %H часов : %M минут')
			);
		});
	});
}